import { Block } from 'webiq.boilerplate'

export default class Register extends Block {
	static title = 'register'

	init() {
		// i know this code is bad
		this.stepOne = this.getElement('step-one')
		this.stepTwo = this.getElement('step-two')
		this.stepThree = this.getElement('step-three')
		this.messageStepOne = this.getElement('message-step-one')
		this.messageStepTwo = this.getElement('message-step-two')
		this.previewWebisteInput = this.getElement('domain-preview--input')
		this.submitButton = this.stepTwo.querySelector('.button--register-step')
		this.icon = this.stepOne.querySelector('.register__password--icon i')
		this.firstButton = this.stepOne.querySelector('.button--next-step')
		this.loader = this.stepTwo.querySelector('.register__domain-preview--loader')
		this.messageEmail = this.getElement('message-email')
		this.messageDivision = this.getElement('message-division')

		document.querySelector('.register.form').reset()

		this.firstButton.addEventListener('click', e => {
			e.preventDefault()

			const stepOneFields = this.stepOne.querySelectorAll('input')
			const emptyFields = this.hasEmptyFields(stepOneFields)

			if (emptyFields) {
				this.messageStepOne.classList.add('register__message-step-one--active')
				this.messageStepOne.classList.add('register__message-step-one--active-bold')
				setTimeout(() => {
					this.messageStepOne.classList.remove('register__message-step-one--active-bold')
				}, 1000)
			} else {
				const emailInput = this.stepOne.querySelector('input[type="email"]')
				if (emailInput.value.match(/^[_a-z0-9-+]+(\.[_a-z0-9-+]+)*(\+[a-z0-9-]+)?@[a-z0-9-.]+(\.[a-z0-9]+)$/)) {
					this.messageStepOne.classList.remove('register__message-step-one--active')
					this.stepOne.classList.add('register__step-one--hidden')
					this.stepTwo.classList.add('register__step-two--active')
				} else {
					this.messageEmail.classList.add('register__message-email--active')
					this.messageEmail.classList.add('register__message-email--active-bold')
					setTimeout(() => {
						this.messageEmail.classList.remove('register__message-email--active-bold')
					}, 1000)
				}
			}
		})

		const companyInput = this.element.querySelector('[name="fields[company]"]')
		companyInput.addEventListener('change', e => {
			this.setLoading(true)

			const payload = new FormData()
			payload.append('name', e.target.value)
			payload.append('convert_shortname', '1')
			payload.append('ajax', '1')

			fetch(window.location.href, {
				method: 'POST',
				body: payload,
				credentials: 'same-origin',
			})
				.then(response => response.json())
				.then(json => {
					this.setLoading(false)
					this.previewWebisteInput.value = json.result
				})
				.catch(error => console.log(error))
		})

		const domainInput = this.element.querySelector('[name="fields[subdomain]"]')
		domainInput.addEventListener('change', e => {
			this.setLoading(true)

			this.submitButton.disabled = true
			const payload = new FormData()
			payload.append('name', e.target.value)
			payload.append('convert_shortname', '1')
			payload.append('ajax', '1')

			fetch(window.location.href, {
				method: 'POST',
				body: payload,
				credentials: 'same-origin',
			})
				.then(response => response.json())
				.then(json => {
					this.setLoading(false)
					this.previewWebisteInput.value = json.result
					this.submitButton.disabled = false
				})
				.catch(error => console.log(error))
		})

		this.element.addEventListener('submit', e => {
			e.preventDefault()
			this.submitButton.disabled = true

			const payload = new FormData()
			payload.append('division', this.previewWebisteInput.value)
			payload.append('check_division', '1')
			payload.append('ajax', '1')

			fetch(window.location.href, {
				method: 'POST',
				body: payload,
				credentials: 'same-origin',
			})
				.then(response => response.json())
				.then(json => {
					if (json.division.result.valid) {
						this.submitButton.disabled = false
						const payload = new FormData(this.element)
						payload.append('ajax', '1')
						this.submitButton.disabled = true
						this.stepTwo.querySelector('.mdc-text-field').classList.remove('mdc-text-field--invalid')
						this.messageStepTwo.classList.remove('register__message-step-two--active')
						this.messageDivision.classList.remove('register__message-division--active')

						fetch(window.location.href, {
							method: 'POST',
							body: payload,
							credentials: 'same-origin',
						})
							.then(response => response.json())
							.then(json => {
								if (json.result) {
									this.stepTwo.classList.remove('register__step-two--active')
									this.stepThree.classList.add('register__step-two--active')
								}
							})
							.catch(error => console.log(error))
					} else {
						this.submitButton.disabled = false
						this.stepTwo.querySelector('.mdc-text-field').classList.add('mdc-text-field--invalid')
						this.messageStepTwo.classList.add('register__message-step-two--active')
						this.messageStepTwo.classList.add('register__message-step-two--active-bold')
						setTimeout(() => {
							this.messageStepTwo.classList.remove('register__message-step-two--active-bold')
						}, 1000)
						this.previewWebisteInput.value = json.division.result.division
						this.messageDivision.classList.add('register__message-division--active')
						setTimeout(() => {
							this.messageStepTwo.classList.remove('register__message-division--active-bold')
						}, 1000)
					}
				})
				.catch(error => console.log(error))
		})
	}

	hasEmptyFields(inputs) {
		for (const input of inputs) if (!input.value) return true
		return false
	}

	setLoading(bool) {
		if (bool) {
			this.loader.classList.add('register__domain-preview--loader-active')
		} else {
			this.loader.classList.remove('register__domain-preview--loader-active')
		}
	}
}
